module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/protocolo-assunto/protocolo-assunto.component.css
// module id = ./src/app/protocolo-assunto/protocolo-assunto.component.css
// module chunks = main